import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { goBack } from "../../../../utils/modules/EmptyCart/utils/navigation.js";
import { EmptyCart } from "../../../../components/modules/EmptyCart/components/EmptyCart.js";
const EmptyCartContainer = ({ onClick = goBack }) => {
  const { getLabel } = useIntl();
  const labels = {
    cartTitle: getLabel("cart.title"),
    emptyCartTitle: getLabel("cart.emptyCart.title"),
    emptyCartMessage: getLabel("cart.emptyCart.message"),
    buttonCaption: getLabel("cart.actions.goBack")
  };
  return /* @__PURE__ */ React.createElement(EmptyCart, { labels, onClick });
};
export {
  EmptyCartContainer
};
//# sourceMappingURL=EmptyCartContainer.js.map
